// src/components/common/StatusChip.js
import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { CheckCircle as CheckCircleIcon, Error as ErrorIcon, Warning as WarningIcon } from '@mui/icons-material';

const StatusChip = ({ status, label, size = 'small', icon = true }) => {
  const theme = useTheme();
  
  // Determine color based on status
  let color, bgColor, textColor, StatusIcon;
  
  switch (status) {
    case 'active':
    case 'success':
    case 'online':
      color = theme.palette.success.main;
      bgColor = `${theme.palette.success.main}1a`;
      textColor = theme.palette.success.main;
      StatusIcon = CheckCircleIcon;
      break;
    case 'warning':
    case 'pending':
      color = theme.palette.warning.main;
      bgColor = `${theme.palette.warning.main}1a`;
      textColor = theme.palette.warning.main;
      StatusIcon = WarningIcon;
      break;
    case 'inactive':
    case 'error':
    case 'offline':
    case 'failed':
      color = theme.palette.error.main;
      bgColor = `${theme.palette.error.main}1a`;
      textColor = theme.palette.error.main;
      StatusIcon = ErrorIcon;
      break;
    default:
      color = theme.palette.info.main;
      bgColor = `${theme.palette.info.main}1a`;
      textColor = theme.palette.info.main;
      StatusIcon = null;
  }
  
  return (
    <Chip 
      size={size} 
      label={label || status.toUpperCase()}
      icon={icon && StatusIcon ? <StatusIcon fontSize="small" /> : undefined}
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: 'medium',
        borderRadius: '6px',
        '& .MuiChip-icon': {
          color: 'inherit',
        }
      }}
    />
  );
};

export default StatusChip;